import { t } from '@lingui/macro';
import React from 'react';
import PropTypes from 'prop-types';

import { setStorage, StorageTypes } from '@helpers/storage';

const ExpandSidebarButton = ({ collapsed, setCollapsed }) => {
  const handleToggle = () => {
    setCollapsed((prevState) => {
      setStorage(StorageTypes.Local, 'assetModalAttachmentsSidebarCollapsed', !prevState);
      BF.fx.dispatchWindowEvent('updateSidebarCollapsed', null, { isCollapsed: !prevState });
      return !prevState;
    });
  };

  return (
    <button
      aria-expanded={!collapsed}
      aria-label={collapsed ? t`Back` : t`Collapse sidebar`}
      className="expand-sidebar-button"
      onClick={handleToggle}
      type="button"
    >
      <span className="bff-arrow-right" />
      <span className="bff-arrow-left" />
    </button>
  );
};

ExpandSidebarButton.propTypes = {
  collapsed: PropTypes.bool,
  setCollapsed: PropTypes.func.isRequired,
};

ExpandSidebarButton.defaultProps = {
  collapsed: false,
};

export default ExpandSidebarButton;
